import { service } from 'common/service'

type HmacResponse = {
  hmac: string
  email: string
}

type HmacRequest = Record<string, never>

type UpdateProfileResponse = {
  success: boolean
}

type UpdateProfileRequest = Record<string, never>

export const crispService = service.injectEndpoints({
  endpoints: (builder) => ({
    getCrispHmac: builder.mutation<HmacResponse, HmacRequest>({
      query: () => {
        return {
          method: 'POST',
          url: `${document.location.origin}/api/crisp/hmac/`,
        }
      },
    }),
    updateCrispPeopleProfile: builder.mutation<
      UpdateProfileResponse,
      UpdateProfileRequest
    >({
      query: () => {
        return {
          method: 'POST',
          url: `${document.location.origin}/api/crisp/update-profile/`,
        }
      },
    }),
  }),
})

export const { useGetCrispHmacMutation, useUpdateCrispPeopleProfileMutation } =
  crispService
